@if (showBackNavigation()) {
  <div class="flex px-4 pt-2 w-full text-lg items-center bg-gray-light">
    <div
      id="settings-back-to-scandata"
      class="p-1 text-primary cursor-pointer hover:bg-gray-0"
      (click)="viewScandata()"
    >
      Reality Capture
    </div>

    <div class="mx-1 text-sm text-gray-4">></div>
    <div>{{ translations.breadcrumbs.settings.text }}</div>
  </div>
}
<div class="h-full flex flex-1 p-4 pt-2 bg-gray-light overflow-hidden">
  <mat-tab-group
    class="flex-1"
    disableRipple
    mat-stretch-tabs="false"
    [selectedIndex]="selectedTabIndex()"
    (selectedTabChange)="tabChange($event)"
  >
    <mat-tab [label]="translations.tabs.storage.text">
      <ng-template matTabContent>
        <sd-config-storage
          class="h-full flex flex-1 flex-col border-t border-gray-0 pt-4"
        ></sd-config-storage>
      </ng-template>
    </mat-tab>
    <mat-tab [label]="translations.tabs.recycleBin.text">
      <ng-template matTabContent>
        <sd-recycle-bin
          class="flex flex-1 flex-col h-full border-t border-gray-0 pt-4"
        ></sd-recycle-bin>
      </ng-template>
    </mat-tab>
    <mat-tab [label]="translations.tabs.classifications.text">
      <ng-template matTabContent>
        <sd-config-classification
          class="h-full flex flex-1 flex-col border-t border-gray-0 pt-4"
        ></sd-config-classification>
      </ng-template>
    </mat-tab>
    @if (showPermissionsTab()) {
      <mat-tab [label]="translations.tabs.permissions.text">
        <ng-template matTabContent>
          <sd-config-permissions
            class="h-full flex flex-1 flex-col border-t border-gray-0 pt-4"
          ></sd-config-permissions>
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>
</div>
